module.exports = __webpack_public_path__ + "static/media/logo.812c567a.svg";